// src/utils/completamentoAttivita.js
// ═══════════════════════════════════════════════════════════════════════════
// CHI COMPLETA UN'ATTIVITÀ (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Le stesse regole ovunque si completi (pannello, Kanban, elenco della commessa, pagina
// Notifiche, sottoattività):
//  • completano chi ha pieni diritti sull'attività (utils/condivisione.js: chi l'ha creata,
//    l'incaricato, il responsabile della commessa, titolare/admin, Gestione aziendale);
//    una sottoattività la completa anche chi l'ha creata o ne è incaricato;
//  • resta scritto chi l'ha completata e quando (completataDaUid / completataDaNome /
//    completedAt), e si cancella se l'attività viene riaperta;
//  • se a completare non è né chi l'ha creata né l'incaricato, compare un messaggio viola
//    (senza nulla da confermare): chi la segue riceve comunque l'avviso (utils/avvisiAttivita.js).
// ═══════════════════════════════════════════════════════════════════════════
import { serverTimestamp, deleteField } from "firebase/firestore";

/** Campi da scrivere insieme allo stato: chi ha completato e quando, o la loro cancellazione. */
export function campiCompletamento(statoDopo, utente) {
  if (statoDopo === "completata") {
    return { completedAt: serverTimestamp(), completataDaUid: utente?.uid || "", completataDaNome: utente?.displayName || utente?.email || "" };
  }
  return { completedAt: deleteField(), completataDaUid: deleteField(), completataDaNome: deleteField() };
}

/**
 * Testo del messaggio viola quando si completa un'attività di altri (null se chi completa
 * l'ha creata o ne è incaricato). sotto = sottoattività.
 */
export function avvisoCompletamentoDiAltri(item, uid, sotto = false) {
  if (!item || !uid) return null;
  if (item.createdBy === uid || item.assignedTo === uid) return null;
  const cosa = sotto ? "una sottoattività" : "un'attività";
  const creatore = item.createdByName || item.creatoDaNome || "";
  const incaricato = item.assignedTo && item.assignedTo !== item.createdBy ? (item.assignedName || "") : "";
  const persone = [creatore, incaricato].filter(Boolean);
  if (creatore && incaricato) return `Hai completato ${cosa} creata da ${creatore} e assegnata a ${incaricato}: sono stati avvisati.`;
  if (creatore) return `Hai completato ${cosa} creata da ${creatore}: è stato avvisato.`;
  if (persone.length) return `Hai completato ${cosa} assegnata a ${persone[0]}: è stato avvisato.`;
  return `Hai completato ${cosa} creata da un collega: chi la segue è stato avvisato.`;
}

/** «Completata da Luca Esposito il 16/10/2026» (vuoto se non c'è l'informazione). */
export function testoCompletataDa(item) {
  if (!item || item.status !== "completata") return "";
  const d = item.completedAt?.toDate?.();
  const quando = d ? ` il ${d.toLocaleDateString("it-IT")}` : "";
  return item.completataDaNome ? `Completata da ${item.completataDaNome}${quando}` : (quando ? `Completata${quando}` : "");
}
